module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasItems) ? _c('div', {
    staticClass: "history"
  }, [_c('Header', [_vm._v("История просмотров")]), _c('ListGrid', _vm._l((_vm.history), function(item, index) {
    return _c('Card', {
      key: index,
      attrs: {
        "title": item.title,
        "image": item.image && item.image.small,
        "to": _vm.getActualParse(item),
        "favorite": _vm.saved(item)
      },
      on: {
        "toggle": function($event) {
          return _vm.toggle(item)
        }
      }
    })
  }), 1)], 1) : _c('Warning', [_c('p', [_vm._v("Здесь будет собрана коллекция программ и мероприятий, просмотренных на сайте.\nЭто очень удобно, когда вам надо вспомнить, в какой программе или мероприятии вы видели ту или иную информацию.")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78e7a0a0","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/history/History.vue
// module id = 730d83294a8916ed6807
// module chunks = 4